export default {
    LOAD_PRODUCTCOLORS (state, productcolors) {
        state.items = productcolors
    },
    LOAD_COLORS_BY_PRODUCT (state, productcolors) {
        state.colors = productcolors
    }
}